import { render, staticRenderFns } from "./IvaVentas.vue?vue&type=template&id=f6fe4168&"
import script from "./IvaVentas.vue?vue&type=script&lang=js&"
export * from "./IvaVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports